<template>
  <div>
    <div class="d-flex mb-3">
      <h1 class="h4 primary--text">
        {{ $t('views.shipment_notice_details.shipment_notice_details') }}
      </h1>
      <div class="ml-auto d-flex">
        <router-link
          to="/asn"
          class="shipment-notice__back-link my-auto"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
          >
            <path
              d="M9,4l.881.881L6.394,8.375H14v1.25H6.394l3.487,3.494L9,14,4,9Z"
              transform="translate(-4 -4)"
            />
          </svg>
          {{ $t('views.shipment_notice_details.back_to_list') }}
        </router-link>
      </div>
    </div>

    <app-loader v-if="loading" />

    <div v-else>
      <main class="shipment-notice__main">
        <b-row>
          <b-col cols="6">
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.asn_date') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.date }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_list.system_status') }}
              </div>
              <div class="shipment-notice__value">
                {{ $t(`enums.asn_system_statuses.${asn.systemStatus}`) }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.asn_number') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.number }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.shipment_date') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.shippingDate }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('common.supplier') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.supplier.asdb }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('common.supplier_name') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.supplier.name }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.shipto') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.plant.asdb }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('common.seller') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.seller.asdb }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('common.buyer') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.buyer.asdb }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.shipping_name') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.shippingName }}
              </div>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.contract') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.contract.name }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.lotNumber') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.lotNumber }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.container_number') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.containerNumber }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.carrier') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.carrier }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.freight_bill_number') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.freightBillNumber }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.net_weight') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.netWeightKg }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.gross_weight') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.grossWeightKg }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.estimated_date') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.estimatedDate }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label" />
              <div class="shipment-notice__value" />
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.bill_of_lading') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.billOfLading }}
              </div>
            </div>
            <div
              v-if="asn.invoiceRu"
              class="mb-3"
            >
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.invoice_date') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.invoiceRu.date }}
              </div>
            </div>
            <div
              v-if="asn.invoiceRu"
              class="mb-3"
            >
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.invoice_number') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.invoiceRu.number }}
              </div>
            </div>
            <div
              v-if="asn.TORG12"
              class="mb-3"
            >
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.torg_12_date') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.TORG12.date }}
              </div>
            </div>
            <div
              v-if="asn.TORG12"
              class="mb-3"
            >
              <div class="shipment-notice__label">
                {{ $t('views.shipment_notice_details.torg_12_number') }}
              </div>
              <div class="shipment-notice__value">
                {{ asn.TORG12.number }}
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="shipment-notice__label">
              {{ $t('views.shipment_notice_list.comment') }}
            </div>
            <div class="shipment-notice__value">
              {{ asn.comment }}
            </div>
          </b-col>
        </b-row>
      </main>

      <shipment-notice-parts
        :parts="asn.details"
        readonly
      />

      <shipment-notice-packing
        :packing="asn.packing"
        :parts="asn.details"
        readonly
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AppLoader from '@/components/common/AppLoader.vue';
import ShipmentNoticeParts from '@/components/asn/ShipmentNoticeParts.vue';
import ShipmentNoticePacking from '@/components/asn/ShipmentNoticePacking.vue';

export default {
  name: 'ShipmentNoticeDetails',

  components: {
    AppLoader,
    ShipmentNoticeParts,
    ShipmentNoticePacking,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      asn: {
        supplier: {},
        buyer: {},
        seller: {},
        plant: {},
        TORG12: {},
        invoiceRu: {},
      },
      loading: false,
    };
  },

  computed: {
    ...mapState({ supplierData: 'supplier' }),
  },

  created() {
    this.getItem();
  },

  methods: {
    async getItem() {
      this.loading = true;
      try {
        const params = { populate: 'origin' };
        const { data = {} } = await this.$http.get(`/asn/${this.id}`, { params });
        this.asn = {
          ...data,
          number: (data.number && data.number !== '0') ? data.number : '',
          date: this.getDate(data.date, 'L LT'),
          shippingDate: this.getDate(data.shippingDate, 'L LT'),
          estimatedDate: this.getDate(data.estimatedDate, 'L LT'),
          createdAt: this.getDate(data.createdAt, 'L'),
          invoiceRu:
            data.invoiceRu
            && data.invoiceRu.number
            && {
              number: data.invoiceRu.number,
              date: this.getDate(data.invoiceRu.date, 'L', 'Europe/Moscow'),
            },
          TORG12:
            data.TORG12
            && data.TORG12.number
            && {
              number: data.TORG12.number,
              date: this.getDate(data.TORG12.date, 'L', 'Europe/Moscow'),
            },
        };
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },

    getDate(date, format = 'LLL', tz) {
      if (!date) { return ''; }

      const mDate = tz ? this.$moment.tz(date, tz) : this.$moment(date);

      return ((new Date(date)).toISOString() !== '1970-01-01T00:00:00.000Z')
        ? mDate.format(format) : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.shipment-notice__back-link {
  text-decoration: none;
  transition: color 0.3s ease-in-out 0s;

  svg {
    fill: #ad7c59;
    margin-right: 5px;
    transition: fill 0.3s ease-in-out 0s;
  }

  &:hover {
    color: var(--margaritas);

    svg {
      fill: var(--margaritas);
    }
  }
}

.shipment-notice__main {
  padding: 25px;
  background-color: #fff;

  .shipment-notice__label {
    font-size: 20px;
    font-weight: 500;
    color: var(--topaz);
  }

  .shipment-notice__value {
    font-size: 18px;
    color: var(--topaz);
    min-height: 27px;
  }
}
</style>
